<template>
  <v-container>
    <v-card flat>
      <v-card-title>
        Emails com erro
        <v-spacer></v-spacer>
        <v-btn @click="handleClickRetryAll()" color="primary" outlined>
          <v-icon left>mdi-refresh</v-icon>
          Reprocessar tudo
        </v-btn>
      </v-card-title>

      <v-data-table
        :loading="loading"
        :headers="headers"
        :items="items"
        height="calc(100vh - 210px)"
        fixed-header
      >
        <template v-slot:item.status="{ item }">
          <v-chip v-if="item.retrying" color="grey" dark>
            <v-icon left size="20"> mdi-clock-outline </v-icon>
            Reprocessando
          </v-chip>
          <v-chip v-else color="red" dark>
            <v-icon left size="20"> mdi-alert-circle-outline </v-icon>
            Erro
          </v-chip>
        </template>

        <template v-slot:item.last_attempt_at="{ item }">
          <span
            v-text="item.last_attempt_at_diff"
            :title="item.last_attempt_at"
          ></span>
        </template>

        <template v-slot:item.actions="{ item }">
          <div>
            <v-btn
              @click="handleClickRetry(item.email_id)"
              color="blue"
              title="Reprocessar"
              icon
            >
              <v-icon>mdi-refresh</v-icon>
            </v-btn>
            <v-btn
              @click="handleClickCancel(item.email_id)"
              color="red"
              title="Cancelar"
              icon
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card>
    <ConfirmationDialog ref="confirmation"></ConfirmationDialog>
  </v-container>
</template>

<script>
import { index, cancel, retry, retryAll } from "@/services/email_reader";
import ConfirmationDialog from "@/components/tools/ConfirmationDialog.vue";
import ToastsMixin from "@/mixins/ToastsMixin.vue";

export default {
  mixins: [ToastsMixin],

  components: {
    ConfirmationDialog,
  },

  props: {},

  data() {
    return {
      loading: false,
      items: [],
      pooling: null,
      headers: [
        {
          text: "Status",
          value: "status",
        },
        {
          text: "Assunto",
          value: "email_subject",
        },
        {
          text: "Erro",
          value: "error_message",
        },
        {
          text: "Data",
          value: "last_attempt_at",
        },
        {
          text: "",
          value: "actions",
          sortable: false,
          width: 120,
          align: "center",
        },
      ],
    };
  },

  methods: {
    async loadItems() {
      this.loading = true;

      try {
        const response = await index();

        this.items = response.data.data;
      } finally {
        this.loading = false;
      }
    },

    handleClickCancel(id) {
      this.$refs.confirmation.confirm(
        "Cancelar o processamento do email?",
        async ({ close, startLoading, stopLoading }) => {
          startLoading();
          try {
            await cancel(id);
            this.loadItems();
            close();
            this.toast("Email cancelado");
          } finally {
            stopLoading();
          }
        },
        null,
        {
          color: "red",
          cancelText: "Manter",
          confirmText: "Cancelar",
        }
      );
    },

    handleClickRetryAll() {
      this.$refs.confirmation.confirm(
        "Reprocessar todos os emails?",
        async ({ close, startLoading, stopLoading }) => {
          startLoading();
          try {
            await retryAll();
            this.loadItems();
            close();
            this.toast("Reprocessando tudo");
          } finally {
            stopLoading();
          }
        },
        null,
        {
          color: "primary",
          cancelText: "Cancelar",
          confirmText: "Reprocessar",
        }
      );
    },

    async handleClickRetry(id) {
      try {
        await retry(id);
        this.loadItems();
        this.toast("Reprocessando email");
      } catch (error) {
        this.toastError("Não foi possível repetir o processamento do email");
        console.error(error);
      }
    },
  },

  computed: {},

  created() {
    this.loadItems();

    this.pooling = setInterval(() => this.loadItems(), 5000);
  },

  beforeDestroy() {
    clearInterval(this.pooling);
  },
};
</script>
